import { FaceLoginAttempt } from '@reliance/types/models/FaceLoginAttempt';
import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { useAsync } from 'react-async-hook';
import api from '../common/api';

export type FaceLoginAttemptFilters = PaginationFilters & {
  inmateId?: number;
  facilityId?: number;
  reason?: string;
  passed?: string | boolean;
};

export const useFaceLoginAttemptsByInmateId = (
  inmateId: number | null | undefined,
  filters?: FaceLoginAttemptFilters
) => {
  return useAsync<PaginatedResponse<FaceLoginAttempt>>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }

      return api
        .get<PaginatedResponse<FaceLoginAttempt>>('/face-login-attempt', {
          params: {
            ...filters,
            inmateId: id,
          },
        })
        .then((response) => response.data);
    },
    inmateId === null ? [] : [inmateId, filters]
  );
};
